"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paragraphCollectionContentFragment = void 0;
exports.paragraphCollectionContentFragment = `
fragment paragraphCollectionContent on ParagraphCollectionContent {
  paragraphs {
    title {
      ...singleLineContent
    }
    body {
      ...richTextContent
    }
    images {
      ...image
    }
  }
}
`;
//# sourceMappingURL=paragraph-collection-content.js.map